'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useAuth } from '@/context/AuthContext';
import { useOrganization } from '@/context/OrganizationContext';
import { useUserRole } from '@/context/UserRoleContext';
import { applySentryUserContext } from '@/utils/observability/sentryUserContext';

/** Keeps the browser's Sentry user/gym tags in step with sign-in, gym switch and role switch. */
export default function SentryUserContext(): null {
  const { user } = useAuth();
  const { currentOrganization } = useOrganization();
  const { currentUser } = useUserRole();

  const userId = user?.id ?? null;
  const organizationId = currentOrganization?.id ?? null;
  const organizationSlug = currentOrganization?.slug ?? null;
  const userType = currentUser?.userType ?? null;
  const staffRole = currentUser?.activeRole ?? null;

  useEffect(() => {
    try {
      applySentryUserContext(Sentry, { userId, organizationId, organizationSlug, userType, staffRole });
    } catch {
      // Observability must never break the page.
    }
  }, [userId, organizationId, organizationSlug, userType, staffRole]);

  return null;
}
